import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import RenderIf from '../../render-if/components/render-if';

import '../styles/default-checkbox.css';

export default class DefaultCheckbox extends Component {
  handleLabelClick(name, value) {
    this.props.input.onChange(!this.props.input.value);
  }

  openExternalUrl(url) {
    window.open(url, '_blank');
  }

  render() {
    const {
      input,
      input: { value, name },
      label,
      externalUrl,
      externalUrlLabel,
      id,
      customError,
      meta: { touched, error },
    } = this.props;
    const { t } = this.context;

    const hasError = touched && (error || customError);

    return (
      <div className="default-checkbox">
        <label
          onClick={() => {
            this.handleLabelClick(name, value);
          }}
          htmlFor={id || name}
          className={`default-checkbox__container ${value ? 'active' : ''}`}
        >
          <input type="checkbox" id={id || name} name={name} value={value} {...input} className="input" />
          {t(label || '')}
        </label>
        <RenderIf if={externalUrl && externalUrlLabel}>
          <span className="external-url" onClick={() => this.openExternalUrl(externalUrl)}>
            {t(externalUrlLabel || '')}
          </span>
        </RenderIf>
        <div className="error">{hasError ? this.context.t(error || customError) : ''}</div>
      </div>
    );
  }
}

DefaultCheckbox.contextTypes = {
  t: PropTypes.func.isRequired,
};

connect(state => ({
  lang: state.i18nState.lang,
}))(DefaultCheckbox);



// WEBPACK FOOTER //
// ./src/app/shared/default-checkbox/components/default-checkbox.js